'use es6';

import { hasStrongRtl } from '../../../utils/text';
const RTL = 'rtl';
const LTR = 'ltr';
const getHandleKeyUp = editor => {
  return function handleKeyUp() {
    const dom = editor.dom;
    const block = editor.selection.getSelectedBlocks()[0];
    if (!block) {
      return;
    }
    const {
      textContent
    } = block;
    if (textContent.trim() === '') {
      return;
    }

    // current block direction
    const curDir = dom.getAttrib(block, 'dir');

    // direction of text in block
    const isRtl = hasStrongRtl(textContent);
    if (isRtl && curDir !== 'ltr' && editor.settings.directionality === RTL || isRtl && curDir === RTL || !isRtl && curDir === LTR || textContent === '') {
      return;
    }
    if (!dom.getParent(block.parentElement, `*[dir="${curDir}"]`, dom.getRoot())) {
      dom.setAttrib(block, 'dir', isRtl ? RTL : null);
    }
  };
};
export const addHandlers = editor => {
  const handleKeyUp = getHandleKeyUp(editor);
  editor.on('keyUp', handleKeyUp);
};